const EXCLUDED_PREFIXES = [
  '/api',
  '/uploads',
  '/game-assets',
  '/static',
  '/admin',
];

const EXCLUDED_PATHS = [
  '/favicon.ico',
  '/robots.txt',
  '/sitemap.xml',
  '/manifest.json',
  '/asset-manifest.json',
];

function hasFileExtension(pathname = '') {
  return /\/[^/]+\.[^/]+$/.test(pathname);
}

export function shouldUseTrailingSlash(pathname = '') {
  if (!pathname || pathname === '/') {
    return false;
  }

  if (EXCLUDED_PATHS.includes(pathname) || hasFileExtension(pathname)) {
    return false;
  }

  return !EXCLUDED_PREFIXES.some((prefix) => (
    pathname === prefix || pathname.startsWith(`${prefix}/`)
  ));
}

export function toCanonicalPath(pathname = '/') {
  if (!shouldUseTrailingSlash(pathname) || pathname.endsWith('/')) {
    return pathname || '/';
  }

  return `${pathname}/`;
}

export function toCanonicalLocation({ pathname = '/', search = '', hash = '' }) {
  return `${toCanonicalPath(pathname)}${search}${hash}`;
}

export function getPublicSiteOrigin() {
  const envUrl = process.env.REACT_APP_PUBLIC_SITE_URL?.trim();

  if (envUrl) {
    return envUrl.replace(/\/+$/, '');
  }

  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.origin;
}

export function getCanonicalUrl({ pathname = '/' }) {
  const canonicalPath = toCanonicalPath(pathname);

  if (canonicalPath !== '/' && !shouldUseTrailingSlash(canonicalPath)) {
    return null;
  }

  return `${getPublicSiteOrigin()}${canonicalPath}`;
}
